export default __webpack_public_path__ + "9d2a9a784d8e1fe8350376529874e427.ico";